import { render, staticRenderFns } from "./PersonalSettingsEditName.vue?vue&type=template&id=5d455e5a&scoped=true"
import script from "./PersonalSettingsEditName.vue?vue&type=script&lang=js"
export * from "./PersonalSettingsEditName.vue?vue&type=script&lang=js"
import style0 from "./PersonalSettingsEditName.vue?vue&type=style&index=0&id=5d455e5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d455e5a",
  null
  
)

export default component.exports